const actions = {
  UPDATE_CONTACT_FORM: 'update_contact_form',
  UPDATE_CONTACT_FORM_MULTIPLE: 'update_contact_form_multiple',
  UPDATE_EBOOK_EMAIL: 'update_ebook_email'
};

export default actions;